// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2wS5r","form":"form___1v8IU"};